/* eslint-disable @repo/internal/no-useTranslation */
import { useTranslation } from "react-i18next";
import { cs } from "../translations";

type NestedKeyOf<ObjectType extends object, Depth extends number[] = []> = Depth["length"] extends 100 // Recursion limit
    ? never
    : {
          [Key in keyof ObjectType & string]: ObjectType[Key] extends object
              ? `${Key}` | `${Key}.${NestedKeyOf<Extract<ObjectType[Key], object>, [...Depth, 0]>}`
              : Key;
      }[keyof ObjectType & string];
// Generic translation keys type for other projects (default schema = typeof cs)
export type TranslationKeys<T extends object = typeof cs> = NestedKeyOf<T>;

/**
 * Custom hook for typed translations based on cs.json
 */
export function useTypedTranslation<T extends object = typeof cs>() {
    const { t } = useTranslation();
    const typedT = (key: TranslationKeys<T>, options?: Record<string, unknown>) => t(key, options);
    return { t: typedT };
}
